import React, { Component, PropType } from 'react';
// import SettingsComponent from '../PinboardComponents/SettingsComponent';
import ModalComponent from "../../../adminpanel/components/commonComponents/ModalComponent";
import Form from "../../../adminpanel/components/commonComponents/Form.v2";
import CalenderComponent from './CalenderComponent.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setFilter, removeFilter, setDashboardComponent, handle_transpose_table, handle_compare, handle_quadrant, setDashboardConfig, setInsightFunction, handle_dataLabel_Overlap, setMetricRange, getGlobalFilters } from '../../actions/index';
import RangeMetricComponent from './RangeMetricComponent';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import TopModalComponent from './TopModalComponent';
import '../../../public/css/Topfilters.css'
import { DBService } from "../SummaryComponents/component/IndexedDB"
import BreadcrumbComponent from '../../../adminpanel/components/commonComponents/BreadcrumbComponent';
import AsyncSelect from 'react-select/async';
var Select = require('react-select');

var textMarginTop = { marginTop: '10px' };
var textMarginBottom = { marginTop: '-6px' };
var styleData = { backgroundColor: "white", color: "black" }
var padStyle = { padding: "3px 20px", cursor: 'pointer' }
var $mega_filter = null;
var $SelectedBreakUpDisp = null, $propertyDisp = null, $handleChange = null, $metricFunction = {};
var handleSliderGlobal;
var metricRangeInputObj = [];
var metricRangeInput;
var selectedMetricWithRangeGlobel = [], chartToSwitch = [], dashboardRangeType = null

var pinToDashboardVar = {
    "pinTitle": {
        "name": "pinTitle", "label": "Visual Title", "type": "text", "text_value": "", requiredFlag: true
    },
    "selectCategory": {
        "name": "selectCategory", "label": "Select Category", "type": "hide", "text_value": "local", "options": [
            { "name": "All", "value": "" },
            { "name": "Local", "value": "local" },
            { "name": "Global", "value": "global" },
        ], requiredFlag: true
    },
    "selectDashboard": {
        "name": "selectDashboard", "label": "Select Report", "type": "dropdown", "text_value": "", "options": [], requiredFlag: true
    },
    "selectType": {
        "name": "selectType", "label": "Select Type", "type": "dropdown", "text_value": "", "options": [
            { "name": "Select Type", "value": "" },
            { "name": "Bookmark (Static)", "value": "static" },
            { "name": "Report (Dynamic)", "value": "dynamic" },
        ], requiredFlag: true
    }
}

// var datasetClass = "clearfix mg-b-10"
// let ishomePage  = window.location.pathname == "/" || window.location.pathname == "/start" 



class Topfilters extends React.Component {
    constructor(props) {
        super(props);
        if (dataLabels != '1') {
            this.state = {
                dataLabelsButton: "Add Data Labels",
                insightEnable: false,
                usablePinToDashboardVar: JSON.parse(JSON.stringify(pinToDashboardVar)),
                modalName: null,
                modalEvent: null,
                ...props
            }
        } else {
            this.state = {
                dataLabelsButton: "Remove Data Labels",
                insightEnable: false,
                usablePinToDashboardVar: JSON.parse(JSON.stringify(pinToDashboardVar)),
                modalName: null,
                modalEvent: null,
                ...props
            }
        }
        this._db = new DBService();
        this.pinHandle = this.pinHandle.bind(this);
        this.handleTranposeTable = this.handleTranposeTable.bind(this);
        this.handleCompare = this.handleCompare.bind(this);
        this.handleAnalysis = this.handleAnalysis.bind(this);
        this.chartConfigHandle = this.chartConfigHandle.bind(this);
        this.downloadHandelAction = this.downloadHandelAction.bind(this);
        this.getBudgetForSelectedMetric = this.getBudgetForSelectedMetric.bind(this);
        this.handleCompareChart = this.handleCompareChart.bind(this);
        this.frequency_change_handle = this.frequency_change_handle.bind(this);
        this.analysisChangeEvent = this.analysisChangeEvent.bind(this);
        // this.save_report_handle = this.save_report_handle.bind(this);
        this.pin_click_handle = this.pin_click_handle.bind(this);
        this.handleSyncClick = this.handleSyncClick.bind(this);
        this.dashboard_change_handle = this.dashboard_change_handle.bind(this);
        this.onChangeHandle = this.onChangeHandle.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.globalFilterInputHandler = this.globalFilterInputHandler.bind(this);
        this.updateGlobalFilters = this.updateGlobalFilters.bind(this);
    }
    frequency_change_handle(e) {
        if (e.target.name == "frequency") {
            this.setState({
                savedReportFrequency: e.target.value
            })
        }
    }
    analysisChangeEvent(e) {
        this.setState({
            analysisValue: e.target.value
        })
    }
    openrefs = (type) => {
        this.props.setInsightFunction({ insight: false, enableDescription: false });
        if (this.state.filter == true || (this.state.filter == "null" && defaultFilterFlag == '1')) {
            defaultFilterFlag = '0'
            this.props.removeFilter()
        }
        else {
            defaultFilterFlag = '1'
            this.props.setFilter()
        }
        // if(type=="filter")
        //     this.props.allData.refs.alfredComponentRef.openSetting();
        // else if(type=="openSidebarInsight")
        //     this.props.allData.refs.sidebarInsightRef.openSidebarInsight();
        // else if(type=="handleSaveReportClick")
        //     this.props.allData.refs.sidebarInsightRef.handleSaveReportClick();
        // else if(type=="handleOpenMetricRangePopup")
        //     this.handleOpenMetricRangePopup();
        // else if(type=="switchButton")
        //     this.props.allData.refs.sidebarInsightRef.switchButton();
    }
    chartConfigHandle(data) {
        this.props.setDashboardConfig(data);
        jQuery("#dashSettings").modal("hide")
    }
    // filterHandle(e, type, callback) {
    //     var arrayData = [], input = '';
    //     // lib.asyncFilter(input, 'propLabel', callback);
    //     arrayData = $mega_filter ? $mega_filter : [];
    //     var check = checkInArray(arrayData, e[0]);
    //     if (!check) {
    //         if (typeof e == "object") {
    //             if (e.length)
    //                 arrayData.push(e[0]);
    //             else arrayData.push(e);
    //         } else {
    //             arrayData.push(e);
    //         }
    //         $mega_filter = arrayData;
    //         this.filterValuesToShow();
    //         // this.handleChange(arrayData);
    //     }
    //     this.refs.megaFilter.loadOptions("");
    // }
    handleOpenMetricRangePopup = () => {
        handleSliderGlobal = this.handleSlider;
        jQuery('#metricRangePopup').modal('toggle');
        var tempSelectedMetric = selectedMetricDisp;
        selectedMetricWithRangeGlobel = [];
        tempSelectedMetric.map(function (val, index) {
            var temp = {};
            var metricValue = (val.value).split(';');
            var unit = val.metricUnit;
            if (unit) {
                if (val.metricPrefix == 'true')
                    temp['prefix'] = unit;
                else
                    temp['postfix'] = unit ? unit : '';
            }
            metricValue = metricValue[0] + '__' + metricValue[1];
            temp['min'] = val.min;
            temp['max'] = val.max;
            temp['from'] = val.from;
            temp['to'] = val.to;
            temp['type'] = 'double';
            // temp['grid'] = true;
            // temp['grid_num'] = 10;
            temp['onFinish'] = handleSliderGlobal;
            temp['prettify_separator'] = ',';
            var ionRangeSlider = jQuery("#" + metricValue).data('ionRangeSlider');
            if (ionRangeSlider) {
                ionRangeSlider.reset();
                ionRangeSlider.update(temp);
            } else {
                jQuery("#" + metricValue).ionRangeSlider(temp);
            }
            selectedMetricWithRangeGlobel[metricValue] = metricValue.replace('__', ';') + ':' + val.from + ':' + val.to;
        });
    }
   
    componentWillReceiveProps(nextProps) {
        this.setState({ ...nextProps.allData.props })
    }
    componentDidMount() {
        this.setState({ globalFilterValues: this.props.globalFilters });
    }
    handleSlider = (e) => {
        var id = jQuery(e.input).attr('id');
        selectedMetricWithRangeGlobel[id] = id.replace('__', ';') + ':' + e.from + ':' + e.to;
    }
    handleMetricRangeSave = () => {
        this.props.updateMetricRange((Object.values(selectedMetricWithRangeGlobel)).toString());
    }
    getMetricRangeButton = () => {
        var metricRange = null;
        if (this.props.allData) {
            if (this.props.property && this.props.selectedMetricDisp && (this.props.allData.state.period == '' || this.props.allData.state.period == 'aggregate' || this.props.allData.state.period === undefined)) {  // don't show metric range button if there is no property
                // var metricRange = <button className='btn btn-contrast btnTopFilter' title='Select metric range.' data-toggle='modal' id='metricRangeButton' data-toggle="tooltip" data-placement="bottom" onClick={this.openrefs.bind(this,'handleOpenMetricRangePopup')}><i className="fa fa-arrows-h"></i></button>;
                metricRange = <li><a style={padStyle} onClick={this.openrefs.bind(this, 'handleOpenMetricRangePopup')} id='metricRangeButton' >Metric Range</a></li>
                var tempSelectedMetric = this.props.selectedMetricDisp;
                if (tempSelectedMetric) {
                    metricRangeInput = tempSelectedMetric.map(function (val, index) {
                        var metricValue = (val.value).split(';');
                        metricValue = metricValue[0] + '__' + metricValue[1];
                        return <div key={index} style={{ overflow: 'hidden', marginBottom: '12px', borderBottom: '0.01px solid #99a4ac' }} >
                            <div className='col-md-4'><label style={{ lineHeight: '50px', marginBottom: '0px' }} htmlFor={metricValue}>{val.label}</label></div>
                            <div className='col-md-7'><input type="text" className="example_id" style={{ marginTop: '5%' }} name="example_name" id={metricValue} value="" /></div>
                        </div>;
                    });
                }
            }
            else
                var metricRange = null;
        }
        return metricRange;
    }
    downloadCsv = () => {
        var url = location.search;
        url = url.replace('property', 'selectedProperty');
        url = url.replace('propertyValues', 'selectedPropertyValue');
        url = url.replace('selectedMetric', 'selectedMetric');
        url = url.replace('breakup', 'breakUp');
        url = url.replace('breakup', 'breakUp');
        window.open("/dashboard/report/gettable" + url + "&download=1");
    }
    onChangeHandle = (e) => {
        this.state.usablePinToDashboardVar[e.target.name].text_value = e.target.value
    }
    dashboard_change_handle = (e) => {
        var tempVar = this.state.usablePinToDashboardVar;
        if (e.target.name === "selectDashboard") {
            if (e.target.selectedOptions[0] && e.target.selectedOptions[0].id)
                dashboardRangeType = e.target.selectedOptions[0].id
            if (e.target.value === "create_new_dashboard") {
                let { pinTitle, selectCategory, selectDashboard, ...rest } = this.state.usablePinToDashboardVar;
                tempVar = {
                    pinTitle,
                    selectCategory,
                    selectDashboard,
                    "nameDashboard": {
                        "name": "nameDashboard", "label": "Name Report", "type": "text", "text_value": "", requiredFlag: true
                    },
                    "selectWorkbook": {
                        "name": "selectWorkbook", "label": "Select Workbook", "type": "dropdown", "text_value": "", "options": [], requiredFlag: true
                    },
                    ...rest
                };
            } else if (dashboardRangeType && dashboardRangeType.includes('dynamic')) {
                dashboardRangeType = dashboardRangeType.split('|')
                tempVar = {
                    ...this.state.usablePinToDashboardVar,
                    "timeRange": {
                        "name": "timeRange", "label": "Select Time Range", "type": "dropdown", "text_value": dashboardRangeType[1], "options": [
                            { "name": "Select Time Range", "value": "" },
                            { "name": "Month till date", "value": "0_MTD" },
                            { "name": "Year till date", "value": "0_YTD" },
                            { "name": "Last quarter", "value": "0_LQ" },
                            { "name": "Last 1 Month", "value": "1_month" },
                            { "name": "Last 2 Month", "value": "2_month" },
                            { "name": "Last 3 Month", "value": "3_month" },
                            { "name": "Last 6 Month", "value": "6_month" },
                            { "name": "Last 9 Month", "value": "9_month" },
                            { "name": "Last 12 Month", "value": "12_month" },
                            { "name": "Last 13 Month", "value": "13_month" },
                            { "name": "Last 15 Month", "value": "15_month" },
                            { "name": "Last 18 Month", "value": "18_month" },
                            { "name": "Last 21 Month", "value": "21_month" },
                            { "name": "Last 24 Month", "value": "24_month" },
                            { "name": "Last 36 Month", "value": "36_month" }
                        ], requiredFlag: true, disabled: true
                    }
                }
            } else {
                let { pinTitle, selectCategory, selectDashboard, nameDashboard, selectWorkbook, nameWorkbook, ...rest } = this.state.usablePinToDashboardVar;
                tempVar = {
                    pinTitle,
                    selectCategory,
                    selectDashboard,
                    ...rest
                };
                tempVar['timeRange'] ? delete tempVar['timeRange'] : null
            }
        } else if (e.target.name === "selectType") {
            if (e.target.value === "dynamic") {
                tempVar = {
                    ...this.state.usablePinToDashboardVar,
                    "timeRange": {
                        "name": "timeRange", "label": "Select Time Range", "type": "dropdown", "text_value": "", "options": [
                            { "name": "Select Time Range", "value": "" },
                            { "name": "Month till date", "value": "0_MTD" },
                            { "name": "Year till date", "value": "0_YTD" },
                            { "name": "Last quarter", "value": "0_LQ" },
                            { "name": "Last 1 Month", "value": "1_month" },
                            { "name": "Last 2 Month", "value": "2_month" },
                            { "name": "Last 3 Month", "value": "3_month" },
                            { "name": "Last 6 Month", "value": "6_month" },
                            { "name": "Last 9 Month", "value": "9_month" },
                            { "name": "Last 12 Month", "value": "12_month" },
                            { "name": "Last 13 Month", "value": "13_month" },
                            { "name": "Last 15 Month", "value": "15_month" },
                            { "name": "Last 18 Month", "value": "18_month" },
                            { "name": "Last 21 Month", "value": "21_month" },
                            { "name": "Last 24 Month", "value": "24_month" },
                            { "name": "Last 36 Month", "value": "36_month" }
                        ], requiredFlag: true
                    }
                }
            } else {
                tempVar = {
                    ...this.state.usablePinToDashboardVar
                }
                delete tempVar['timeRange'];
            }
        } else if (e.target.name === "selectWorkbook") {
            if (e.target.value === "create_new_workbook") {
                let { pinTitle, selectCategory, selectDashboard, nameDashboard, selectWorkbook, ...rest } = this.state.usablePinToDashboardVar;
                tempVar = {
                    pinTitle,
                    selectCategory,
                    selectDashboard,
                    nameDashboard,
                    selectWorkbook,
                    "nameWorkbook": {
                        "name": "nameWorkbook", "label": "Name Workbook", "type": "text", "text_value": "", requiredFlag: true
                    },
                    ...rest
                };
            } else {
                let { pinTitle, selectCategory, selectDashboard, nameDashboard, selectWorkbook, nameWorkbook, ...rest } = this.state.usablePinToDashboardVar;
                tempVar = {
                    pinTitle,
                    selectCategory,
                    selectDashboard,
                    nameDashboard,
                    selectWorkbook,
                    ...rest
                };
            }
        }
        tempVar[e.target.name].text_value = e.target.value;
        this.setState({ usablePinToDashboardVar: tempVar })
    }
    pin_click_handle = (e) => {
        e.preventDefault();
        let checkValidity = true
        var title = this.state.usablePinToDashboardVar.pinTitle.text_value.trim();
        if (checkValidity) {
            checkValidity = checkSpecialChars(title, 'pinInsert') ? false : true
        }
        var sel_Category = this.state.usablePinToDashboardVar.selectCategory ? this.state.usablePinToDashboardVar.selectCategory.text_value.trim() : null;
        var dashboard_id = this.state.usablePinToDashboardVar.selectDashboard.text_value.trim();
        var dashboard_value = this.state.usablePinToDashboardVar.nameDashboard ? this.state.usablePinToDashboardVar.nameDashboard.text_value.trim() : null;
        if (dashboard_value !== null && checkValidity) {
            checkValidity = checkSpecialChars(dashboard_value, 'pinInsert') ? false : true
        }
        var dashboard_group = this.state.usablePinToDashboardVar.selectWorkbook ? this.state.usablePinToDashboardVar.selectWorkbook.text_value.trim() : null;
        var name_work = this.state.usablePinToDashboardVar.nameWorkbook ? this.state.usablePinToDashboardVar.nameWorkbook.text_value.trim() : null;
        if (name_work !== null && checkValidity) {
            checkValidity = checkSpecialChars(name_work) ? false : true
        }
        var sel_Type = this.state.usablePinToDashboardVar.selectType.text_value.trim();
        var dashboard_time_range = this.state.usablePinToDashboardVar.timeRange ? this.state.usablePinToDashboardVar.timeRange.text_value.trim() : null;

        if (checkValidity === false) {
            alert('Please enter valid inputs!');
            jQuery("#pin_handle").trigger("reset");
        } else {
            if (dashboard_group === "create_new_workbook") {
                dashboard_group = name_work;
                if (dashboard_group == null || dashboard_group == "") {
                    dashboard_group = "Default";
                }
            } else {
                dashboard_group = dashboard_group && dashboard_group != 'null'
                    ? dashboard_group
                    : sel_Category == 'local'
                        ? this.props.dashbordGroups.filter((innerData) => {
                            if (innerData.idDashboard == dashboard_id)
                                return innerData;
                        })
                        : this.props.allDashboards.dashbordGroups.filter(function (innerData) {
                            if (innerData.idDashboard == dashboard_id)
                                return innerData;
                        });
                dashboard_group = Array.isArray(dashboard_group) ? dashboard_group[0].dashboard_group : dashboard_group;
            }
            this.pinHandle(title, dashboard_id, dashboard_value, dashboard_time_range, dashboard_group, 'pin', {}, sel_Category);
            jQuery('#pin_handle').modal('toggle');
            this.handleSyncClick();
            this.setState({
                usablePinToDashboardVar: JSON.parse(JSON.stringify(pinToDashboardVar))
            })
        }
    }
    modalCancel = () => {
        this.setState({
            usablePinToDashboardVar: JSON.parse(JSON.stringify(pinToDashboardVar))
        })
    }
    tableGridSizeSave = () => {
        // var fd = new FormData();
        // fd.append('agGridData', JSON.stringify(gridOptions.columnApi.getColumnState()));
        // jQuery.ajax({
        //     type: 'POST',
        //     data: fd,
        //     url: '/dashboard/report/dataresize',
        //     contentType: false,
        //     processData: false,
        //     success: function (response) {
        //         if (document.getElementById('saveGridSetting'))
        //             document.getElementById('saveGridSetting').style.display = "none";
        //         alert("Successfully Updated.");
        //     }
        // });
    }
    downloadPDF = () => {
        var currentURL = location.href;
        var url = '';
        window.open('/dashboard/report/downloadpdf?url=' + encodeURIComponent(data_url) + "&type=" + this.props.type + "&currenturl=" + encodeURIComponent(currentURL), '_blank');
    }
    // save_report_handle(e) {
    //     e.preventDefault();
    //     var title = document.getElementById("reportName_form_data").value;
    //     var outputPeriod = document.getElementById("outputPeriod_form_data").value;
    //     var shareTo = jQuery("#shareTo_form_data").val();
    //     var frequency = document.getElementById("frequency_form_data").value;
    //     var dayOfWeek = document.getElementById("dayOfWeek_form_data") ? document.getElementById("dayOfWeek_form_data").value : null;
    //     var dayOfMonth = document.getElementById("dayOfMonth_form_data") ? document.getElementById("dayOfMonth_form_data").value : null;
    //     var timeOfDay = { "time": document.getElementById("timeofDay_form_data").value, "date": dayOfMonth, "day": dayOfWeek };
    //     this.pinHandle(title, null, null, outputPeriod, null, "report", { "share": shareTo, "frequency": frequency, dayOfWeek: dayOfWeek, dayOfMonth: dayOfMonth, timeOfDay: timeOfDay })
    // }
    pinHandle(title, dashboard_id, dashboard_value, dashboard_time_range, dashboard_group, type = "pin", reportObj = {}, dashboardCategory = "local") {
        var data = {};
        let URL = window.location.href;
        var URL_data = URL.split("?");
        var params = new URLSearchParams(URL_data[1]);
        let chartCat = this.props.allData.props.chartCat;
        let currentPageName = this.props.allData.props.currentPageName;
        let pageName = this.props.allData.props.pageName;
        let componentType, status = null;
        if (currentPageName.toLowerCase() == "chartdata" || pageName.toLocaleLowerCase() == 'chart') {
            componentType = "Chart";
            status = validationInput(this.props.allData.props.property, this.props.allData.props.metricValue, this.props.allData.props.period ? this.props.allData.props.period : "", this.props.allData.props.chartCat.toLowerCase(), "all")
            data.chartDisp = chartCat;
            data.chart = status.chartDisp ? status.chartDisp : chartCat;
        } else if (currentPageName.toLowerCase() == "report") {
            componentType = "Report";
            if (this.props.allData.props.crosstab_flag === false && this.props.allData.props.property.includes(',')) {
                let leftDim = this.props.allData.props.property.split(',')
                data.aboveDim = leftDim.pop()
                data.leftDim = leftDim.toString()
            } else {
                data.aboveDim = ""
                data.leftDim = this.props.allData.props.property
            }
        } else if (currentPageName.toLowerCase() == "summary") {
            componentType = "Summary";
            data.returnType = 'total';
            data.type = 'summary';
        }

        data.removeGlobalFilter = this.props?.allData?.props?.removeGlobalFilter?this.props?.allData?.props?.removeGlobalFilter:null

        if (pageName == "pinboard") {
            data.dashboard_id = id_dashboard
            componentType = "Dashboard"
        } else {
            if (dashboard_time_range) {
                dashboard_time_range = dashboard_time_range.split("_");
                data.startDate = '{"date_method":"endDate","count":"' + (dashboard_time_range[0] - 1) + '","date_format":"' + dashboard_time_range[1] + '"}';
                data.endDate = '{"date_method":"endDate"}';
            } else {
                data.startDate = this.props.allData.props.startDate;
                data.endDate = this.props.allData.props.endDate;
            }
            let labelShow;
            if (metricGlobal && (pin_metric_value || this.props.allData.props.selectedMetric))
                labelShow = getLabel(metricGlobal, pin_metric_value ? pin_metric_value : this.props.allData.props.selectedMetric, this.props.allData.props.propertyDisp, this.props.allData.props.SelectedBreakUpDisp, null, null, this.props.allData.props.includeDisp, this.props.allData.props.excludeDisp);
            data.category = this.props.allData.props.property;
            // data.metric = this.props.allData.props.selectedMetric;
            // data.selectedMetric = this.props.allData.props.selectedMetric;
            data.metric = data.selectedMetric = pin_metric_value ? pin_metric_value : this.props.allData.props.selectedMetric;
            data.breakUp = this.props.allData.props.SelectedBreakUp;
            data.include = this.props.allData.props.include;
            data.exclude = this.props.allData.props.exclude;
            data.chartType = this.props.allData.props.period;
            data.chartDispStyle = this.props.allData.props.period;
            data.period = this.props.allData.props.period;
            data.analysis = this.props.allData.props.analysis;
            data.regressionLine = this.props.allData.props.regressionLine;
            data.clusterCount = this.props.allData.props.clusterCount;
            data.chartCat = chartCat;
            data.sortOrder = this.props.allData.props.sortOrder;
            data.limit = this.props.allData.props.limit;
            data.transpose = this.props.allData.props.transpose;
            data.kpiMonitoring = this.props.allData.props.kpiMonitoring;
            data.compare = this.props.allData.props.compare;
            data.multiDim = this.props.allData.props.crosstab_flag;
            data.ColumnWidth = tableColumnWidth
            if (labelShow) {
                data.metricText = labelShow.metricText;
                data.propertyText = labelShow.propertyText;
                data.breakupText = labelShow.breakupText;
                data.includeText = labelShow.includeText;
                data.excludeText = labelShow.excludeText;
            } else {
                data.metricText = '';
                data.propertyText = '';
                data.breakupText = '';
                data.includeText = '';
                data.excludeText = '';
            }
            data.metricRange = this.props.allData.props.metricRange;
            if (this.props.type == 'charts') {
                data.dataPointConfig = this.props.dataLabelConfig?.dataLabelConfig
                data.yAxisFlag = this.props.dataLabelConfig?.yAxis
            }
            if (this.props.kpiMonitoring == 'true' || this.props.kpiMonitoring == true) {
                data.kpiColumnConfig = this.props.kpiColumnConfig
            }
        }
        var userId = this.props.authData.userId;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");
        var dataset = JSON.parse(localStorage.Dataset);
        let that = this
        if (type == 'pin') {
            let postData = {
                'parameter': JSON.stringify(data),
                'componentType': componentType,
                'pin_title': title,
                'dashboard_value': dashboard_value,
                'dashboard_group': dashboard_group,
                'dashboard_id': dashboard_id,
                'type': dashboardCategory,
                'userId': userId            }
            let params = {
                'toolId': dataset.toolId,
                'siteId': dataset.siteId
            }
            CallAPI('POST', '/app/pinInsert', postData, params, 0, function (response) {
                checkIfSessionTimedOut(response)
                if (response && response.status == false) {
                    alert(response.information)
                } else alert('Successfully Pinned.');
                that.props.setDashboardComponent({ 'siteId': `${dataset.siteId}`, 'toolId': `${dataset.toolId}`, 'userId': userId, 'sessionId': that.props.authData.sessionId })
                pin_metric_value = null
            }, that.props.authData)

            /* Commented jQuery.ajax call, changed it to above CallAPI */
            // var fd = new FormData();
            // fd.append('parameter', JSON.stringify(data));
            // fd.append('componentType', componentType);
            // fd.append('pin_title', title);
            // fd.append('dashboard_value', dashboard_value);
            // fd.append('dashboard_id', dashboard_id);
            // fd.append('dashboard_group', dashboard_group);
            // fd.append('type', dashboardCategory);
            // fd.append('userId', userId);

            // jQuery.ajax({
            //     type: 'POST',
            //     url: `/app/pinInsert?toolId=${dataset.toolId}&siteId=${dataset.siteId}`,
            //     headers: { Authorization: authorization_value },
            //     dataType: 'json',
            //     data: postData,
            //     contentType: false,
            //     processData: false,
            //     success: function (response) {
            //         checkIfSessionTimedOut(response)
            //         alert('Successfully Pinned.');
            //         jQuery('#pinForm')[0].reset();
            //         jQuery('select option[value="default"]').attr("selected", true);
            //         document.getElementById("dashboad_name_component").style.display = "none";
            //         document.getElementById("dashboard_group_component").style.display = "none";
            //         document.getElementById("dashboard_group_name_component").style.display = "none";
            //         document.getElementById("dashboard_value").value = 'default'
            //         this.props.setDashboardComponent({ 'siteId': `${dataset.siteId}`, 'toolId': `${dataset.toolId}`, 'userId': userId })
            //     }.bind(this)
            // });           
        }
        // else {
        //     let final_data = {};
        //     final_data.reportData = data;
        //     final_data.reportType = componentType;
        //     final_data.frequency = reportObj.frequency;
        //     final_data.timing = reportObj.timeOfDay;
        //     final_data.name = title;
        //     final_data.email = reportObj.share;
        //     final_data.toolId = dataset.toolId;
        //     final_data.siteId = dataset.siteId;
        //     final_data.userId = userId;

        //     let postURL = `/app/save_report_data?toolId=${dataset.toolId}&siteId=${dataset.siteId}&userId=${userId}`;
        //     CallAPI('POST', postURL, final_data, null, 0, function (innerData) {
        //         alert("Saved Report");
        //         jQuery('#savedReportModal').modal('hide')
        //     }, this.props.authData)
        // }

    }
    handleTranposeTable = (e) => {
        let transposeValue = this.props.transpose == true ? false : true
        let currentUrl = window.location.search + `&transpose=${transposeValue}`
        let urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
        updateURL(urlObj, '', false)
        this.props.handle_transpose_table({ transpose: transposeValue, kpiMonitoring: false })
    }
    handleChartDataLabelOverlap = (e) => {
        let dataLabelValue = this.props.dataLabelOverlap == true ? false : true;
        this.props.handle_dataLabel_Overlap({ dataLabelOverlap: dataLabelValue })
    }
    // handleCompareOld = (e) => {
    //     let compareValue = this.props.compare == true || this.props.compare == "true" ? false : true;
    //     let currentUrl = window.location.search + `&compare=${compareValue}`
    //     let urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
    //     updateURL(urlObj, '', false)
    //     this.props.handle_compare({ compare: compareValue })
    // }
    handleCompare = (e) => {
        let currentUrl = window.location.search
        let metrics = getParametersFromString('metric', currentUrl)
        if (metrics) {
            var newMetrics = []
            metrics = metrics.split(',');
            metrics.forEach(element => {
                let tempMetric = element.split(';')[0]
                newMetrics.push(`${element}`)
                newMetrics.push(`${tempMetric};ly`)
            });
            this.props.filterHandleChange({ "selectedMetric": newMetrics.join(','), clicked: 'metric' });
        }
    }
    handleAnalysis = (e) => {
        let analysisType = document.getElementById("analysisType_form_data").value;
        let clusterCount = document.getElementById("clusterCount_form_data").value;

        let condition = true
        if (analysisType == "true") {
            condition = clusterCount >= 2 ? true : false
        }

        if (condition) {
            let currentUrl = window.location.search + `&analysis=${analysisType}&clusterCount=${clusterCount}`
            let urlObj = Object.fromEntries(new URLSearchParams(currentUrl));
            updateURL(urlObj, '')
            this.props.handle_quadrant({ analysis: analysisType, clusterCount: clusterCount })

            jQuery("#analysisSetting").modal('hide');
        } else {
            alert("Cluster count should be greater than or equal to 2");
        }
    }
    handlePageInsight = (e) => {
        this.props.setInsightFunction({ insight: true, enableDescription: false, insightDate: null, point: 'page' });
    }
    componentDidUpdate() {
        feather.replace()
        if (SKIN_MODE == "dark") {
            jQuery(".btn-white").addClass("btn-dark");
            jQuery(".btn-white").removeClass("btn-white");
        }
    }
    downloadHandelAction = (e) => {
        var exportFileName = document.getElementById("exportFileName_form_data").value;
        var exportType = document.getElementById("exportType_form_data").value;
        if (exportFileName) {
            if (this.props.type == "report") {
                let params = { fileName: exportFileName, columnGroups: true }
                if (exportType == "excel") {
                    let params = { fileName: exportFileName, columnGroups: false }
                    gridOptions.api.exportDataAsExcel(params);
                } else if (exportType == "csv")
                    gridOptions.api.exportDataAsCsv(params);
            } else {
                let params = { filename: exportFileName, type: exportType }
                highChartsDiv.exportChart(params)
            }

            document.getElementById("exportFileName_form_data").value = "";
            jQuery("#exportSettings").modal("hide")
        } else {
            alert("Please type Filename");
        }
        e.preventDefault(); // Prevent page refresh on form submit
    }
    getBudgetForSelectedMetric=() => {
        let that = this;
        // let budgetObject = this.props.allData.props.metricDisp.filter(val => val.budget)
        let budgetValue = that.props.allData.props?.metricDisp?.length > 0 && this.props.allData?.props?.metricDisp.map(item => item.budget);
        return budgetValue
    }
    handleCompareChart = (val) => {
        let growthCompareTo = this.props.allData?.props?.dataSet?.userDBSetting[0]?.growthCompareTo
        let compareFunction = getParameters('compareChart') && getParameters('compareChart').toLowerCase() == 'growth' || val.toLowerCase() == 'growth'
            ? (growthCompareTo == '0' || growthCompareTo == '3' ? 'ly' : growthCompareTo == '2' ? 'lm' : "wk")
            : this.getBudgetForSelectedMetric(newSelectedMetric)
        
            function cleanArrayOfObjects(arr) {
            return arr.map(obj => {
                let cleanedObj = { ...obj };
                if (cleanedObj.hasOwnProperty('value')) {
                    cleanedObj = cleanedObj['value'].split(';')[0];
                }
                return cleanedObj;
            });
        }
        let selectedMetricArray = cleanArrayOfObjects(this.props.selectedMetricDisp)
        let newSelectedMetric = this.props.allData?.props?.selectedMetric;
        var newMetrics = val.toLowerCase() != 'remove' ? (val.toLowerCase() == 'growth') ? (selectedMetricArray?.length > 0 ? selectedMetricArray.map(innerData => `${innerData};${compareFunction}`) : `${selectedMetricArray[0]};${compareFunction}`) : (compareFunction.length > 0 ? compareFunction : '') : true
        if (val == 'remove') {
            let metricsArray = this.props?.selectedMetricDisp.filter(item => !item.value.includes(compareFunction))
            newSelectedMetric = metricsArray.map(item => item.value)
            newSelectedMetric = newSelectedMetric.length > 0 ? newSelectedMetric.join(',') : newSelectedMetric;
        } else {
            newSelectedMetric = this.props.allData.props.selectedMetric + ',' + (val.toLowerCase() == 'growth' ? newMetrics.join(',') : newMetrics)
            let arr = newSelectedMetric.split(',');
            let uniqueArr = [...new Set(arr)];
            newSelectedMetric = uniqueArr.join(',');
        }
        let validCompare = val == 'remove' ? newMetrics : !Object.values(newMetrics).includes("") && !Object.values(newMetrics).includes(null)
        if (compareFunction && validCompare) {
            let new_props = { "selectedMetric": newSelectedMetric, "property": this.props.allData.props.property, "breakup": this.props.allData.props.breakup, "period": this.props.allData.props.period, "clicked": this.props.allData.props.clicked, "include": this.props.allData.props.include, "exclude": this.props.allData.props.exclude, "transpose": this.props.allData.props.transpose, "kpiMonitoring": this.props.allData.props.kpiMonitoring, "crosstab_flag": this.props.allData.props.crosstab_flag, "saveFilterToggle": this.props.allData.props.saveFilterToggle, "sortOrder": this.props.allData.props.sortOrder, "limit": this.props.allData.props.limit, "compare": val == 'remove' ? "false" : val }
            let response = {
                include: this.props.allData.props.includeDisp ? JSON.stringify(this.props.allData.props.includeDisp) : JSON.stringify(getBreakupDisp(this.props.allData.props.include, this.props.allData.props.alfred.property)),
                exclude: this.props.allData.props.excludeDisp ? JSON.stringify(this.props.allData.props.excludeDisp) : JSON.stringify(getBreakupDisp(this.props.allData.props.exclude, this.props.allData.props.alfred.property)),
                filter: this.props.allData.props.SelectedBreakUpDisp ? JSON.stringify(this.props.allData.props.SelectedBreakUpDisp) : JSON.stringify(getBreakupDisp(this.props.allData.props.breakup, this.props.allData.props.alfred.property)),
                property: this.props.allData.props.propertyDisp ? JSON.stringify(this.props.allData.props.propertyDisp) : JSON.stringify(getPropertyDisp(this.props.allData.props.property, this.props.allData.props.alfred.property))
            }
            let finalObj = handleParamsToSet(response, new_props, this.props.allData)
            this.props.allData.props.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true })
            // if (formData != null || formData != undefined) { 
            //     dataLabelConfig({ 'compareConfig': val.toLowerCase() })
            // }  
        }
    }
    
    handleSyncClick = (toolData = null,datasetChange) => {
        let toolID = toolData ? toolData.toolId : this.props.dataSet.toolId
        let indexedDB = this._db
        IDBStoreNames.forEach((e) => {
            if (toolID) {
                indexedDB.deleteByToolId(e, toolID);
            }
        })
        window.localStorage.setItem('redirectTo', JSON.stringify(location));
        handleChangeCalled = false;
        this.props.changeDataSet(toolData ? toolData : toolID, datasetChange);
    }
    handleModalEvent = (modalEventName) => {
        this.setState({ modalName: modalEventName })
    }
    rangeHandleModal = (eventName) => {
        this.setState({ modalEvent: eventName })
    }
    globalFilterHandler(e) {
        jQuery('#globalFilterModal').modal("show")
    }
    globalFilterInputHandler(value) {
        this.setState({
            globalFilterValues: value == null ? [] : value
        })
    }
    modalCancel = () => {
        this.setState({
            globalFilterValues: this.props.globalFilters ? this.props.globalFilters : []
        })
    }
    fetchFilterValues = (params, callback) => {
        let that = this
        asyncFilter(params, 'global_filter', callback, that.props.authData, null, null, that.props.dataSet.toolId)
    }
    updateGlobalFilters(e) {
        e.preventDefault();
        let that = this
        let params = {
            "siteId": localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null, "toolId": that.props.dataSet.toolId
        }
        let postData = {
            "userId": that.props.authData.userId, "temporary_filter": that.state.globalFilterValues
        }
        CallAPI('POST', '/app/setGlobalFilter', postData, params, 0, function (response) {
            if (response.status) {
                alert("Filters updated successfully")
                that.props.getGlobalFilters({
                    siteId: params.siteId,
                    toolId: params.toolId,
                    userId: that.props.authData.userId,
                    sessionId: that.props.authData.sessionId
                })
            }
            jQuery('#globalFilterModal').modal('toggle')
        }, that.props.authData)
    }
    render() {
        var dataset_div = null, analysisComponentVar = null;
        var dataset_name = JSON.parse(localStorage.Dataset).name;
        var datasetClass = "card-header pd-y-2 pd-x-15 custom-filter-padding";
        var breadcrumb;
        // var filterClass = screen_width <= mobile_width && this.props?.type != 'summary' ? "mg-t-3" : "mg-t-3"

        let temp_permanent_filter = this.props.restrictedFilter ? this.props.restrictedFilter : null;
        if (temp_permanent_filter) {
            let truncatedValue = truncateValue(temp_permanent_filter, 15)
            temp_permanent_filter = <span title={temp_permanent_filter} > [Filtered by: <b>{truncatedValue}</b>]</span>;
        }
        // else if ($mega_filter) {
        //     var mega_value = $mega_filter.map(function (innerData, index) {
        //         return innerData.display;
        //     })
        //     mega_value = mega_value.toString();

        //     if (typeof $mega_filter === "object" && $mega_filter.length !== 0) {
        //         temp_permanent_filter = <span id="megaButton" data-toggle="modal" data-target="#mega-filter-button" style={{ cursor: "pointer" }}>(Filter by {mega_value})</span>;
        //     }
        // } else temp_permanent_filter = null;
        var datasetClassFinal = datasetClass;
        breadcrumb = (<BreadcrumbComponent props={this.props} handleGlobalFilter={this.globalFilterHandler}handleSync={this.handleSyncClick} currentPageName={this.props.allData.props.pageName ? this.props.allData.props.pageName : this.props.allData.props.currentPageName} />)
        if (dataset_name && this.props.type != 'notification') {
            // tooltip for Dataset Name : data-toggle="tooltip" title="Dataset Name" data-placement="bottom"
            dataset_div = <span className="mg-b-5" style={{ backgroundColor: '#e2e2e2', height: '35px', padding: '6px' }}>
                <i className="text-contrast fa fa-database"></i>{`${dataset_name}${temp_permanent_filter}`}
            </span>;
            dataset_div = <div className="btn-group btn-group-sm" role="group" aria-label="Basic Group">
                <button type="button" className="btn btn-white bd-r-0" id="datasetNameIcon">
                    <i className="text-contrast fa fa-database"></i> {dataset_name}
                    {temp_permanent_filter}
                </button>
                <button type="button" className="btn btn-white bd-l-0" data-bs-toggle="tooltip" data-placement="right"
                    title={`Last Updated: ${moment(this.props.dataSet.userDBSetting[0].endTime.split(' ')[0]).format("Do MMM YYYY")}.` + ` Click to Refresh`} onClick={() => this.handleSyncClick()}>
                    <i className="text-contrast fa fa-sync-alt"></i></button>
            </div>
        } else {
            datasetClassFinal = null
        }

        if ((this.props.type !== "dataset" && this.props.allData.props.selectedMetric) || (["pinboard", "globaldashboards"].indexOf(this.props.type) > -1)) {
            var metricRange = this.getMetricRangeButton();
            if (this.props.type == "charts" || this.props.type == "report") {
                var chartCatVar = this.props.type == "report" ? "Table" : this.props.allData.props.chartCat;

                var filterConditions = this.props.allData.props.selectedMetric ? validationInput(this.props.property, this.props.allData.props.selectedMetric, this.props.period ? this.props.period : "", chartCatVar.toLowerCase(), "all") : {};

                chartArray = filterConditions?.compatible;
                if (chartArray) {
                    var data = this.props.allData.state;

                    let old_props = this.state.old_props ? this.state.old_props.property : this.props.property;
                    let new_props = this.state.nextProps ? this.state.nextProps.property : this.props.property;

                    let isPropertyLabel = new_props && new_props.indexOf(';') == -1 ? true : false

                    var statePeriod = encodeURIComponent(data['chartType']);
                    var stateChartType = encodeURIComponent(data['chartCat']);

                    var currentPeriod = getParameters('chartType');
                    currentPeriod = currentPeriod ? currentPeriod : getParameters('period');

                    var url = '/chart/chartData' + window.location.search;
                    url = url.replace('selectedMetric', 'metric');
                    var currentPage = window.location.pathname.split('/');
                    currentPage = currentPage[2] ? currentPage[2] : currentPage[1]

                    let requiredMetric = getRequiredMetric(this.props)
                    // url = url.replace(`property=${old_props}`, `property=${encodeURIComponent(new_props)}`);
                    let breakupInUrl = encodeURIComponent(getParameterByName('breakup', url));
                    // url = url.replace(`breakup=${breakupInUrl}`, `breakup=${encodeURIComponent(this.props.allData.state.SelectedBreakUp)}`);
                    let metricToReplace = null
                    chartToSwitch = chartArray.map(function (innerData, index) {
                        if(innerData=="Area" && this?.props?.authData?.companyName=="itc") return;
                        url = '/chart/chartData' + window.location.search;
                        url = url.replace('selectedMetric', 'metric');
                        var img = null;
                        metricToReplace = null

                        if (currentPage == 'report')  // for report there is no chartCat so add chartCat in url to redirect
                            url = getParameters('chartCat') ? url.replace('chartCat=' + stateChartType, 'chartCat=' + innerData) : `${url}&chartCat=${innerData}`;
                        // url = url.replace('chartCat='+ stateChartType, 'chartCat='+innerData);
                        else
                            url = url.replace('chartCat=' + stateChartType, 'chartCat=' + innerData);

                        if (innerData == 'Line') {
                            // If period is set other than aggregate and dimension is selected then remove dimension
                            if (currentPeriod && stateChartType) {
                                if (currentPeriod.toLocaleLowerCase() !== 'aggregate') {
                                    if (new_props) {
                                        if (new_props.indexOf(';') == -1) {
                                            new_props = null
                                        }
                                    }
                                }

                                if (stateChartType.toLocaleLowerCase() == 'column' && currentPeriod.toLocaleLowerCase() == 'aggregate')
                                    currentPeriod = getPeriodBasedOnDates(this.props.startDate, this.props.endDate, currentPeriod, stateChartType)
                            }

                            if (currentPeriod && currentPeriod.toLocaleLowerCase() !== 'aggregate') {
                                currentPeriod = currentPeriod
                                if (new_props) {
                                    metricToReplace = requiredMetric['metric1']
                                }
                            }

                            currentPeriod = !currentPeriod ? 'aggregate' : currentPeriod
                            url = url + "&chartType=" + currentPeriod;
                            url = statePeriod ? url.replace('chartType=' + statePeriod, 'chartType=' + currentPeriod) : url
                            img = "/assets/images/chart_new/line_graph.svg";
                        }
                        else if (innerData == 'Table') {
                            metricToReplace = null
                            url = 'report' + window.location.search.replace('metric', 'selectedMetric');
                            stateChartType = decodeURIComponent(decodeURIComponent(stateChartType));

                            // url = url.replace(old_props, encodeURIComponent(new_props));
                            // url = url.replace(`breakup=${this.props.allData.props.data.SelectedBreakUp}`, `breakup=${encodeURIComponent(this.props.allData.state.SelectedBreakUp)}`);

                            // send stateperiod to table when stateperiod is set and one of the following chart
                            // if((statePeriod && statePeriod.toLocaleLowerCase() !== 'aggregate') && (stateChartType && ['column','column stacked','line','bullet',"area"].indexOf(stateChartType.toLocaleLowerCase())>-1))
                            url = url.replace('chartType=', 'period=');
                            // else url = url.replace('chartType='+ statePeriod, 'period=');

                            img = "/assets/images/chart_new/time_table.svg";
                        }
                        else if (innerData == 'Bar') {
                            // metricToReplace = requiredMetric['metric1']
                            img = "/assets/images/chart_new/bar_graph.svg";
                        }
                        else if (innerData == 'Column') {
                            if (currentPeriod && currentPeriod.toLocaleLowerCase() !== 'aggregate') {
                                currentPeriod = currentPeriod
                                if (isPropertyLabel) {
                                    metricToReplace = requiredMetric['metric1']
                                }
                            } else {
                                currentPeriod = 'Aggregate';
                            }

                            // if(stateChartType && ['line','report','column stacked','bullet',"area"].indexOf(stateChartType.toLocaleLowerCase())==-1)
                            //     currentPeriod = 'Aggregate';
                            url = url + "&chartType=" + currentPeriod;
                            url = statePeriod ? url.replace('chartType=' + statePeriod, 'chartType=' + currentPeriod) : url;
                            img = "/assets/images/chart_new/column_graph.svg";
                        }
                        else if (innerData == 'Pie') {
                            metricToReplace = requiredMetric['metric1']
                            img = "/assets/images/chart_new/pie_chart.svg";
                        }
                        else if (innerData == 'Scatter') {
                            metricToReplace = requiredMetric['metric2']
                            img = "/assets/images/chart_new/scatterplot.svg";
                        }
                        else if (innerData == 'Bubble') {
                            metricToReplace = requiredMetric['metric3']
                            img = "/assets/images/chart_new/bubble_map.svg";
                        }
                        else if (innerData == 'Map') {
                            img = "/assets/images/chart_new/point_map.svg";
                        }
                        if (!img) {
                            img = this.props.allData.props.dataSet.alfred ? this.props.allData.props.dataSet.alfred.chart_array.All[innerData].img : null;
                        }
                        // url = url.replace(`property=${old_props}`, `property=${encodeURIComponent(new_props)}`);                        
                        url = metricToReplace ? url.replace('metric=' + requiredMetric['urlMetric'], 'metric=' + metricToReplace) : url
                        // target="_blank"
                        return <a className="dropdown-item d-flex align-items-center" href={url} id={`switchChart_${innerData.replace(" ", "")}`} title={innerData} data-placement="right" key={"switch_filter_" + index}>
                            {/* <img className="mg-r-5" style={{width:"25px"}}src={img} /> */}
                            {innerData}
                        </a>;
                    }.bind(this));
                }
            }
            var topFilters = "0px 0px 10px 0px";
            if (this.props.type == "charts") {
                topFilters = "10px 0px 10px 0px";
            }
            var switchChart = null, filter = null, switchChartUl = null, Insight = null, toolPanel = null, showReports = null, saveReport = null, exportButton = null, refreshDatasets = null, exportButtonPDF = null, pin = null, chartConfig = null, compare = null, Quadrant = null, saveGridSetting = null, transpose = null, toolPanelbutton = null, save_report = null, compare_charts = null, compare_options = ['Growth'],
            // commented because only growth is needed now.
            // !this.getBudgetForSelectedMetric(this.props.selectedMetricDisp).includes(null) ? ['Growth'] : ["Growth"] , 
            shortName = null, exportButtonCSV = null, enableInsight = null, SavedReportVar = null, dataLabelOverlap = null, rangeMetricButton = null;
            if (this.props.type == "charts" || this.props.type == "report") {
                /* switch chart */
                // switchChart = <div className={`chat-sidebar-header btnTopFilter mg-r-5 pd-t-3 pd-b-3`} role="group">
                //     <button className='btn-sm btn btn-white btnTopFilter dropdown-toggle' type="button" title='Switch Chart' id='switchChart' role='button' data-toggle="dropdown"><i className="fas fa-chart-bar" data-toggle="tooltip" data-placement="bottom"></i></button>
                //     <div className="dropdown-menu" role="menu" style={{ minWidth: "auto" }}>
                //         {chartToSwitch}
                //     </div>
                // </div>;
                
                //moving switch chart button in more button
                switchChart = <a className={`dropdown-item dropdown-toggle`} data-bs-toggle="dropdown" style={{"cursor":"pointer"}}>
                    {/* <button className='btn-sm btn btn-white btnTopFilter dropdown-toggle' type="button" title='Switch Chart' id='switchChart' role='button' data-toggle="dropdown"><i className="fas fa-chart-bar" data-toggle="tooltip" data-placement="bottom"></i></button>
                    <div className="dropdown-menu" role="menu" style={{ minWidth: "auto" }}> */}
                    Switch chart
                </a>
                // </div>;

                /* Range Metric */
                rangeMetricButton = <a onClick={() => this.rangeHandleModal('rangeMetric')} className="dropdown-item" id="range_handle_button" style={{ cursor: 'pointer' }}>Metric Range</a>
            }
            {/* Compare */ }
            // <a className="dropdown-item" href="#" onClick={that.changedataset.bind(this,innerData.toolId,innerData.siteId)} style={{fontSize:"14px"}}>{innerData.name}</a>
            if (this.props.type === "charts") {
                let chartType = this.props.allData.state.chartType;
                chartType = chartType ? chartType : this.props.allData.state.period;
                chartType = chartType ? chartType.toLowerCase() : chartType
                var check_status = this.props.allData.state.chartCat == "Bar" || (chartType == "aggregate" || chartType == "month" || chartType == "quarter" || chartType == "year") ? true : false;


                var date_status = chartType && chartType == "quarter" ? moment(this.props.allData.state.startDate, 'YYYY-MM-DD').format('YYYY') - moment(this.props.allData.state.endDate, 'YYYY-MM-DD').format('YYYY') == 0 : moment(this.props.allData.state.startDate, 'YYYY-MM-DD').diff(moment(this.props.allData.state.endDate, 'YYYY-MM-DD'), 'days') >= -365;

                if (this.props.type == "charts" && (this.props.allData.state.chartCat == "Column" || this.props.allData.state.chartCat == "Bar" || this.props.allData.state.chartCat == "Line") && check_status && date_status) {
                    // compare=<button type="button" className="btn btn-white btnTopFilter" data-toggle="tooltip" data-placement="bottom" title='Compare' id='compare' onClick={this.props.allData.compareHandle} ><i className="fa fa-calendar-plus-o"></i></button>
                    compare = <a className="dropdown-item" onClick={this.handleCompare} id="compareAction">Compare</a>
                }
            }
            {/* Four Quadrant */ }
            if (this.props.type === "charts" && (this.props.allData.state.chartCat === "Scatter" || (this.props.allData.state.chartCat === "Map" && decodeURIComponent(this.props.allData.state.metricValue).split(',').length >= 2))) {
                // Quadrant=<button type="button" className="btn btn-white btnTopFilter" data-toggle="tooltip" data-placement="bottom" title='4 Quadrant' id='quadrant' onClick={this.props.allData.changeChart.bind(this,'clusterCount','quadrant')} ><i className="fa fa-th-large"></i></button>
                Quadrant = <a className="dropdown-item" onClick={this.handleQuadrant} id="quadrant">Analysis</a>
                Quadrant = <a className="dropdown-item" data-bs-toggle="modal" href='#analysisSetting' id="analysisSettingHandleButton">Analysis</a>

                let analysisOptions = []
                if (checkIfFeatureApplicable('Cluster Analysis') && checkIfFeatureApplicable('Quadrant')) {
                    analysisOptions = [{ "name": "None", "value": "false" }, { "name": "K-Means", "value": "true" }, { "name": "4 Quadrant", "value": "quadrant" }]
                } else if (checkIfFeatureApplicable('Cluster Analysis')) {
                    analysisOptions = [{ "name": "None", "value": "false" }, { "name": "K-Means", "value": "true" }]
                } else if (checkIfFeatureApplicable('Quadrant')) {
                    analysisOptions = [{ "name": "None", "value": "false" }, { "name": "4 Quadrant", "value": "quadrant" }]
                }

                let analysisValue = this.state.analysisValue ? this.state.analysisValue : this.props.allData.props.analysis;
                let formData = {
                    "analysisType": {
                        "name": "analysisType", "label": "Analysis Type", "type": "dropdown", "options": analysisOptions, text_value: analysisValue
                    },
                    "clusterCount": { "name": "clusterCount", "label": "Cluster Count", "type": "number", "disabled": true, text_value: this.props.allData.props.clusterCount }
                }

                if (analysisValue == "true") {
                    formData['clusterCount']["disabled"] = false;
                } else if (analysisValue == "quadrant") {
                    formData['clusterCount']["disabled"] = true;
                    formData['clusterCount']["text_value"] = '4';
                } else {
                    formData['clusterCount']["disabled"] = false;
                    formData['clusterCount']["text_value"] = null;
                }

                var Form_Data = <Form label_array={formData} handle_form_drop_down={this.analysisChangeEvent} />;

                let modalConfig = {
                    "analysisSetting": {
                        "id": "analysisSetting", "form_name": "analysisSetting", "title": "Analysis", "body": Form_Data, "button_name": "Apply", "display": true
                    }
                }
                analysisComponentVar = <ModalComponent modalConfig={modalConfig["analysisSetting"]} action={this.handleAnalysis} />
            }
            {/* filter */ }
            if (this.props.type == "charts" || this.props.type == "report" || this.props.type == "summary" || this.props.type == "pinboard") {
                // filter = <button type="button" className="btn btn-sm btn-white" id="filterOpenDiv" onClick={this.openrefs.bind(this,"filter")}><i className="fa fa-filter"></i></button>
                filter = <div className={this.props.type == "pinboard" && this.props.type != "charts" ? 'filterDiv' : 'pd-r-0'}><button type="button" className={`btn btn-sm btn-white `} title="Filter Settings" id="filterOpenDiv" onClick={this.openrefs.bind(this, "filter")}><i className="fa fa-filter" style={{ fontSize: "10px" }} ></i></button></div>
                // filter=<a href="javascript:void(0)" className="btn btn-white btnTopFilter" id="filterOpenDiv" onClick={this.openrefs.bind(this,"filter")} data-toggle="tooltip" title="Filter Settings" data-placement="bottom"><i className="fa fa-filter"></i></a>
            }
            {/* Insight */ }
            if (this.props.type == "charts" || this.props.type == "report" || this.props.type == "summary") {
                enableInsight = <a href="javascript: false" className="dropdown-item" onClick={this.handlePageInsight} id="pageInsight" style={{ cursor: 'pointer' }}>Show Insight</a>
                // Insight=<button className='btn btn-sm btn-white btnTopFilter' title='Insight' id='insightSidebar' role='button' onClick={this.openrefs.bind(this,"openSidebarInsight")} data-toggle="tooltip" data-placement="bottom" ><i className="fa fa-lightbulb-o"></i></button>
            }
            {/* DataLabels */ }
            if (this.props.type == "charts") {
                dataLabelOverlap = <a href="javascript: false" className="dropdown-item" id="chartDataLabels" onClick={this.handleChartDataLabelOverlap.bind(this)} style={{ cursor: 'pointer' }}>{`${this.props.dataLabelOverlap ? "Hide" : "Allow"} DataLabel Overlap`}</a>
            }
            {/* ToolPanel & Save Resizing Button */ }
            if (this.props.type == "report") {
                // saveGridSetting=<button className='btn btn-white btnTopFilter' title='Save table resizing' id="saveGridSetting" data-toggle="tooltip" data-placement="bottom" style={{display:"none"}} onClick={this.tableGridSizeSave.bind(this)}>Save table resizing</button>
                // saveGridSetting=<a className="dropdown-item" href="#" onClick={this.tableGridSizeSave.bind(this)} id="saveGridSetting">Save table resizing</a>

                // toolPanelbutton=<button className='btn btn-white btnTopFilter' title='Show view table settings to show or hide columns' id="toolPanel" data-toggle="tooltip" data-placement="bottom" ><i className="fa fa-pencil-square-o"></i></button>

                toolPanel = <a className="dropdown-item" id="toolPanel" style={{ cursor: 'pointer' }}>Tool Panel</a>

                // Don't show transpose option in case of time period
                // if(!this.props.period && decodeURIComponent(this.props.property).split(',').length==1){                    
                let transposeCase = this.props.allData.props.propertyDisp && this.props.allData.props.propertyDisp.length > 1 ? false : true
                if (!this.props.period || (transposeCase && this.props.period && this.props.period.toLowerCase() == "aggregate")) {
                    // transpose=<button className='btn btn-white btnTopFilter' title='Transpose Report' id="transposeReport" data-toggle="tooltip" data-placement="bottom" onClick={this.props.changeChart.bind(this, 'transpose')}><i className="fa fa-columns"></i></button>
                    transpose = <a className="dropdown-item" onClick={this.handleTranposeTable} id="transposeReport" style={{ cursor: 'pointer' }}>Transpose Report</a>
                }
                var configureKPIMCButton = this.props.kpiMonitoring == true || this.props.kpiMonitoring == 'true'
                    ? <a className="dropdown-item" id="configureKPIMCols" onClick={() => this.handleModalEvent('configureKPIMCols')} style={{ cursor: 'pointer' }}>KPIM Column Configuration</a>
                    : null
            }
            {/* Open Saved Report */ }
            if (this.props.type == "report") {
                // showReports=<a className='btn btn-white btnTopFilter' title='open saved report page.' href='/dashboard/savedreport' target='_blank' id="showReports" data-toggle="tooltip" data-placement="bottom" ><i className="fa fa-list"></i></a>
                // showReports=<a className="dropdown-item" href="#" target="_blank" href="/dashboard/savedreport" id="showReports">View Saved Reports</a>
            }
            {/* save reports */ }
            if (this.props.type == "report") {
                // saveReport=<button className='btn btn-white btnTopFilter' title='Save new report.' data-toggle='modal' href='#saveReportPopup' id='saveReport' data-toggle="tooltip" data-placement="bottom" onClick={this.openrefs.bind(this,'handleSaveReportClick')}><i className="fa fa-floppy-o"></i></button>
                // saveReport=<a className="dropdown-item" href="javascript:void(0)" onClick={this.openrefs.bind(this,'handleSaveReportClick')} id="saveReport">Save Report</a>
            }
            {/* download */ }
            // exportButtonPDF=<button type="button" className="btn btn-white btnTopFilter" data-toggle="tooltip" data-placement="bottom" title='Export PDF' id='exportPDF' onClick={this.downloadPDF} ><i className="fa fa-file-pdf-o"></i></button>
            // exportButtonPDF=<a className="dropdown-item" href="#" onClick={this.downloadPDF.bind(this)} id="export_PDF">Export PDF</a>
            if (this.props.type == "report") {
                // let shortenName = this.props.allData.props.data.shortenHandle==true || this.props.allData.props.data.shortenHandle=="true" ? "Disable Shorten" : "Enable Shorten";
                // exportButton=<button type="button" className="btn btn-white btnTopFilter" data-toggle="tooltip" data-placement="bottom" title='Export' id='export' onClick={this.downloadCsv} ><i className="fa fa-cloud-download"></i></button>
                // exportButton=<a className="dropdown-item" href="#" onClick={this.downloadCsv.bind(this)} id="export">Export Excel</a>
                // exportButtonCSV = <a id="exportReportCSV" className="dropdown-item" href="#" onClick={this.downloadCsv.bind(this)} id="exportCSV">Export CSV</a>
                // shortName=<a className="dropdown-item" href="#" onClick={this.shortNameSave.bind(this)} id="export">{shortenName}</a>
            }
            if (this.props.type == "charts" || this.props.type == "report") {
                // pin=<button type="button" className="btn btn-white btnTopFilter" data-toggle="modal" data-placement="bottom" title='Pin to Pinboard' id='pin_handle_button' href='#pin_handle' ><i className="fa fa-thumb-tack"></i></button>
                pin = <a className="dropdown-item"  onClick={() => jQuery('#pin_handle').modal('toggle')} id="pin_handle_button" style={{ cursor: 'pointer' }}>Pin to Dashboard</a>
                chartConfig = <a className="dropdown-item" onClick={() => this.handleModalEvent('chartConfig')} id="chart_config" style={{ cursor: 'pointer' }}>Chart Configuration</a>
                //save_report = <a className="dropdown-item" href="#" data-toggle="modal" href='#savedReportModal' id="save_report_button">Save Report</a>
                save_report = <a className="dropdown-item" onClick={() => this.handleModalEvent('saveReport')} id="save_report_button" style={{ cursor: 'pointer' }}>Save Report</a>
                compare_charts = <button className="btn btn-sm btn-outline-info dropdown-toggle" id="top_more_action_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{!getParameters("compareChart") || getParameters("compareChart") == 'false' ? "Compare" : getParameters("compareChart")}</button>
                
                // <a className="dropdown-item" onClick={() => this.handleModalEvent('compareConfig')} id="compare_charts_button" style={{ cursor: 'pointer' }}>Compare Chart</a>

            }
            if (this.props.type == "summary" || this.props.type == "alfred") {
                // var title = this.props.type=="alfred" ? "Export CSV" : "Export";
                // var title = "Export CSV";
                // exportButton=<button type="button" className="btn btn-white btnTopFilter" data-toggle="tooltip" data-placement="bottom" title='Export' id='export' onClick={this.props.allData.handleDownload} ><i className="fa fa-cloud-download"></i></button>
                // exportButton=<a className="dropdown-item" href="#" onClick={this.props.allData.handleDownload} id="export_csv">{title}</a>
                //save_report = <a className="dropdown-item" href="#" data-toggle="modal" href='#savedReportModal' id="save_report_button">Save Report</a>
                save_report = <a className="dropdown-item" onClick={() => this.handleModalEvent('saveReport')} id="save_report_button" style={{ cursor: 'pointer' }}>Save Report</a>
            }
            var top_filter_style = { margin: topFilters, textAlign: "right", display: "inline-block", float: "right" };
            if (filter_enabled !== 1) {
                top_filter_style.display = null;
                top_filter_style.float = null;
            }
            var more_button = this.props.type == "dashboard" ? "d-none" : "pd-r-4 pd-t-3 pd-b-3 dropdown";

            var compare_button = "pd-r-6 pd-t-3 pd-b-3" 
            // let list_of_users_options = [];
            // let listOfUserArray = [];
            // if (JSON.parse(list_users).length > 0) {
            //     list_of_users_options = JSON.parse(list_users).map(function (innerData, index) {
            //         listOfUserArray.push({ "name": innerData.label, "value": innerData.value })
            //         return <option value={innerData.value}>{innerData.label}</option>;
            //     });
            // }

            // Remove more button if in this array
            var MoreButton = ["alfred", "pinboard", "notification", "insight", "globaldashboards"].indexOf(this.props.type) > -1 ? null : <button className="btn btn-sm btn-white dropdown-toggle d-flex justify-content-center align-items-center" data-bs-auto-close="outside" id="top_more_action_button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More</button>;

            // var styleHandle = null
            // var SettingsComponentVar = null
            // if (this.props.type == "charts") {
            //     styleHandle = <a className="dropdown-item" href="#" data-toggle="modal" href='#dashSettings' id="dashSettingHandleButton">Chart Style</a>
            //     SettingsComponentVar = <SettingsComponent details={this.props.authData} dashboard_config={this.props.dashboardConfig} dashboard_change_handle={this.chartConfigHandle} currentPage={"charts"} dataSet={this.props.dataSet} />
            // }

            var ExportComponentVar = null
            let modalConfig = {
                "exportSettings": {
                    "id": "exportSettings", "form_name": "exportSettings", "title": "Export", "body": null, "buttonType": "submit", "button_name": "Export", "display": true
                },
                "pin_handle": {
                    "id": "pin_handle", "form_name": "pin_handle", "form_id": "pin_handleForm", "title": "Pin Details", "body": null, "button_name": "Save", "buttonType": "submit", "display": true, 'formKey': `pin_handleForm_${Math.floor(Math.random() * 10)}`
                }
            }
            if (this.props.type == "charts" || this.props.type == "report" || this.props.type == "summary") {
                exportButton = <a className="dropdown-item" onClick={() => this.handleModalEvent('exportReport')} id="export_report_button" style={{ cursor: 'pointer' }}>Export</a>
                refreshDatasets = <a className="dropdown-item" onClick={() => this.handleSyncClick()} id="refresh_button" style={{ cursor: 'pointer' }}>Refresh Dataset</a>
                //exportButton = <a className="dropdown-item" href="#" data-toggle="modal" href='#exportSettings' id="exportSettingHandleButton">Export</a>
                // Export Options
                var exportOptions;
                if (this.props.type == "summary") {
                    exportOptions = [{ "name": "Excel", "value": "xls" }, { "name": "CSV", "value": "csv" }]
                } else {
                    exportOptions = this.props.type == "report" ? [{ "name": "Excel", "value": "excel" }, { "name": "CSV", "value": "csv", }] : [{ "name": "PNG", "value": "image/png" }, { "name": "JPEG", "value": "image/jpeg" }, { "name": "PDF", "value": "application/pdf" }]
                }

                let formData = {
                    "exportFileName": { "name": "exportFileName", "label": "File Name", "type": "text", requiredFlag: true },
                    "exportType": {
                        "name": "exportType", "label": "Export Type", "type": "dropdown", "options": exportOptions, requiredFlag: true
                    }
                }

                var Form_Data = <Form label_array={formData} />;

                modalConfig['exportSettings']['body'] = Form_Data;

                ExportComponentVar = <ModalComponent modalConfig={modalConfig["exportSettings"]} formSubmit={this.downloadHandelAction} />
            }

            var option_dashboard = [
                { "name": "Select Report", "value": "" },
                { "name": "Create new report", "value": "create_new_dashboard" },
                // { "name": "Create new Dashboard", "value": -1 },
            ];

            if (this.state.usablePinToDashboardVar.selectCategory.text_value.toLocaleLowerCase() == 'local') {
                this.props.dashbordGroups && this.props.dashbordGroups.map(function (innerData) {
                    let type = innerData.type;
                    // type = `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
                    let dashboardRange = ''
                    if (innerData.information) {
                        let parsedInfo = JSON.parse(innerData.information)
                        if (parsedInfo.startDate && parsedInfo.endDate) {
                            let parsedStartDate = JSON.parse(parsedInfo.startDate)
                            dashboardRange = `dynamic|${parseInt(parsedStartDate.count) + 1}_${parsedStartDate.date_format}`
                        } else dashboardRange = 'static'
                    }
                    option_dashboard.push({ "name": `${innerData.name} (${innerData.dashboard_group})`, "value": innerData['idDashboard'], 'id': dashboardRange });
                }.bind(this));
            } else {
                this.props.allDashboards && this.props.allDashboards.dashbordGroups && this.props.allDashboards.dashbordGroups.map(function (innerData) {
                    var name = innerData['name'] === "" || innerData['name'] === null ? "Pinboard " + (parseInt(innerData['idDashboard']) + 1) : innerData['name'];
                    let status = true;
                    switch (this.state.usablePinToDashboardVar.selectCategory.text_value.toLocaleLowerCase()) {
                        case "all":
                            status = innerData.type == 'global' || this.props.dataSet.toolId == innerData.toolId ? true : false
                            break;
                        case "local":
                            status = innerData.type == 'local' && this.props.dataSet.toolId == innerData.toolId ? true : false
                            break;
                        case "global":
                            status = innerData.type == 'global' ? true : false
                            break;
                    }
                    if (status) {
                        let type = innerData.type;
                        type = `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
                        option_dashboard.push({ "name": `${name} (${type})`, "value": innerData['idDashboard'] });
                    }
                }.bind(this));
            }

            let list_of_groups = [
                { "name": "Select Workbook", "value": "" },
                { "name": "Create New Workbook", "value": "create_new_workbook" }
            ];

            let pinboard_groups = [];
            let checkArraydashbordGroups = [];

            if (this.state.usablePinToDashboardVar.selectCategory.text_value.toLocaleLowerCase() == 'local') {
                this.props.dashbordGroups && this.props.dashbordGroups.map(function (innerData) {
                    if (checkArraydashbordGroups.indexOf(innerData.dashboard_group.toLowerCase()) == -1) {
                        pinboard_groups.push({ dashboard_group: innerData.dashboard_group, name: innerData.dashboard_group, type: innerData.type })
                        checkArraydashbordGroups.push(innerData.dashboard_group.toLowerCase())
                    }
                }.bind(this));
            } else {
                this.props.allDashboards && this.props.allDashboards.dashbordGroups && this.props.allDashboards.dashbordGroups.map(function (innerData) {
                    if (checkArraydashbordGroups.indexOf(innerData.dashboard_group.toLowerCase()) == -1) {
                        let status = true;
                        switch (this.state.usablePinToDashboardVar.selectCategory.text_value.toLocaleLowerCase()) {
                            case "all":
                                status = innerData.type == 'global' || this.props.dataSet.toolId == innerData.toolId ? true : false
                                break;
                            case "local":
                                status = innerData.type == 'local' && this.props.dataSet.toolId == innerData.toolId ? true : false
                                break;
                            case "global":
                                status = innerData.type == 'global' ? true : false
                                break;
                        }

                        if (status) {
                            pinboard_groups.push({ dashboard_group: innerData.dashboard_group, name: innerData.dashboard_group, type: innerData.type })
                            checkArraydashbordGroups.push(innerData.dashboard_group.toLowerCase())
                        }
                    }
                }.bind(this));
            }
            if (pinboard_groups.length > 0) {
                let temp_groups = []
                pinboard_groups.map(function (innerData, index) {
                    let name = innerData.dashboard_group;
                    name = `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
                    let type = innerData.type;
                    type = `${type.charAt(0).toUpperCase()}${type.slice(1)}`;
                    // if (index === 0) {
                    //     temp_groups.push(<option selected value='default'>Select Workbook</option>);
                    // }

                    temp_groups.push({ "name": `${name} (${type})`, "value": innerData.dashboard_group });
                });
                list_of_groups = [...list_of_groups, ...temp_groups];
            }

            this.state.usablePinToDashboardVar["selectDashboard"]["options"] = option_dashboard;
            if (this.state.usablePinToDashboardVar['selectWorkbook']) {
                this.state.usablePinToDashboardVar["selectWorkbook"]["options"] = list_of_groups;
            }
            if (["", null, "null"].indexOf(dashboardRangeType) > -1) {
                this.state.usablePinToDashboardVar['selectType']['disabled'] = false
                this.state.usablePinToDashboardVar['timeRange'] ? this.state.usablePinToDashboardVar['timeRange']['disabled'] = false : null
            } else if (dashboardRangeType) {
                this.state.usablePinToDashboardVar['selectType']['text_value'] = dashboardRangeType == 'static' ? dashboardRangeType : dashboardRangeType[0]
                this.state.usablePinToDashboardVar['selectType']['disabled'] = true
            }
            if (this.props.type == "summary") {
                this.state.usablePinToDashboardVar['pinTitle']['type'] = 'hide'
            } else {
                this.state.usablePinToDashboardVar['pinTitle']['type'] = 'text'
            }
            let pinToDashboardForm = <Form label_array={this.state.usablePinToDashboardVar} handle_form_drop_down={this.dashboard_change_handle} handleForm={this.onChangeHandle} />
            modalConfig["pin_handle"]["body"] = pinToDashboardForm;
            modalConfig["pin_handle"]["formKey"] = `pin_handle_${Math.floor(Math.random() * 10)}`;
            let pinToDashboardModal = <ModalComponent modalConfig={modalConfig["pin_handle"]} formSubmit={this.pin_click_handle} cancelEvent={this.modalCancel} />

            let calendarButton = window.location.pathname == "/insight" ? null : <div className='calendarDiv' style={{ marginRight: "5px", fontSize: "14px" }}><CalenderComponent allPropsData={this.props.allData} startDate={this.props.allData ? this.props.allData.props.startDate : this.props.dataSet.startDate} endDate={this.props.allData ? this.props.allData.props.endDate : this.props.dataSet.endDate} startDateDisp={this.props.allData ? this.props.allData.props.startDateDisp : this.props.dataSet.startDateDisp} endDateDisp={this.props.allData.props ? this.props.allData.props.endDateDisp : this.props.dataSet.endDateDisp} page={this.props.allData.props.chartCat} datasetDetails={this.props.allData.props.datasetDetails} granularity={this.props.allData.props.granularity} dashboardConfigDates={this.props.allData.props.dashboardConfigDates} pageName={this.props.allData.props.pageName} enableWTD={this.props.allData.props.dataSet.summarizationDetails[0].granularity} setFiscalYear={this.props.allData.props.dataSet.userDBSetting[0].FYMonthStart} /></div>;

            let globalFilterLabels = '';
            if (this.props.globalFilters && this.props.globalFilters.length > 0) {
                globalFilterLabels = getGlobalFilterDetails(this.props.globalFilters, true)
            }
            let globalFilterBody = <div className="form-group" id="filter_dropdown">
                <AsyncSelect
                    name="globalFilters"
                    ref="globalFilters"
                    key={`global_filter_${Math.floor(Math.random() * 10)}`}
                    cacheOptions
                    loadOptions={this.fetchFilterValues}
                    defaultOptions={true}
                    value={this.state.globalFilterValues ? this.state.globalFilterValues : this.props.globalFilters}
                    onChange={this.globalFilterInputHandler}
                    isMulti={true}
                />
            </div>
            let globalFilterModalConfig = { "id": "globalFilterModal", "form_name": "globalFilter", "form_id": "globalFilterForm", "title": "Global Filter", "body": globalFilterBody, "button_name": "Save", "buttonType": "submit", "display": true, "formKey": `globalFilterForm_${Math.floor(Math.random() * 10)}` }

            return (
                // <div style={top_filter_style}>
                // <div className="d-sm-flex align-items-top justify-content-between mg-b-2 mg-lg-b-2 mg-xl-b-3">
                <div className={datasetClassFinal} style={this.props.ishomePage ? { marginBottom: "-20px" } : this.props.filter_open_body}>
                    {/* {SettingsComponentVar} */}
                    {ExportComponentVar}
                    {analysisComponentVar}
                    {/* {SavedReportVar} */}
                    {/* <div className="col-md-12" style={top_filter_style}> */}
                    {/* 
                        Mega Filter Modal added for the Dataset level filter for the next usage.

                        Date: 15th Jan 2019
                        Usecase: 
                            1. Capital First for filter Live and Non-Live cases.
                            2. Future Generali for Login and Issuance KPI's
                    
                    */}
                    {this.state.modalName
                        ? <TopModalComponent modalEventName={this.state.modalName} allPropsData={this.props.allData.props} dashboard_time_range={this.state.usablePinToDashboardVar.timeRange ? this.state.usablePinToDashboardVar.timeRange.text_value.trim() : null} handleModalEvent={this.handleModalEvent} allProps={this.props} />
                        : null}

                    <div id="commentModal" className="modal fade modal-wide">
                        <div className="modal-dialog" style={{ width: '350px' }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Feedback</h5>
                                    <button aria-hidden="true" className="close" data-dismiss="modal" type="button">×</button>
                                </div>
                                <div className="modal-body box" id="feedback-body" style={{ overflow: 'hidden', padding: "20px" }}>
                                    <div className='row todo-list'>
                                        <div className='col-md-12'>
                                            <div className='box'>
                                                <div className='box-content box-no-padding' style={{ border: 'none' }}>
                                                    <div className='sortable-container'>
                                                        <form autoComplete='off'>
                                                            <ul className="list-unstyled sortable ui-sortable" data-sortable-axis="y" id='feedbackUl' data-sortable-connect=".sortable">
                                                            </ul>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <textarea className='form-control' placeholder="Comment..." rows='6' id='feedbackComment' style={{ display: 'none' }}></textarea>
                                    <input type='hidden' id='hiddenResponse' name="" value='' />
                                    <input type='hidden' id='hiddenFeatureForFeedback' name="" value='' />
                                    <input type='hidden' id='hiddenFeedbackId' name="" value='' />
                                    <button className="btn-sm btn btn-white pull-right" id="sendFeedback" onClick={this.saveComment}>Send</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="userCommentModal" className="modal fade" role="dialog">
                        <div className="modal-dialog" style={{ width: '350px' }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button aria-hidden="true" className="close" data-dismiss="modal" type="button">×</button>
                                    <h5 className="modal-title">Comment</h5>
                                </div>
                                <div className="modal-body box" id="comment-body" style={{ overflow: 'hidden', padding: "20px" }}>
                                    <textarea className='form-control' placeholder="Comment..." rows='6' id='UserComment'></textarea>
                                    <input type='hidden' id='hiddenCommentId' name="" value='' />
                                    <button className="btn-sm btn btn-contrast pull-right" id="sendComment" onClick={this.saveUserComment} style={{ marginTop: '5px', marginBottom: '-7%' }}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="mega-filter-button" className="modal fade" role="dialog" style={{ textAlign: "left" }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Mega Filter</h5>
                                    <button id="closeButton" type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    {/* <button aria-hidden="true" className="close" data-dismiss="modal" type="button">x</button> */}
                                    {/* <span className="modal-title" id="alertData"></span> */}
                                </div>
                                <div className="modal-body box" id="feedback-body" style={{ overflow: "auto", height: "300px" }}>
                                    <div className='' id="filterSelect" style={textMarginTop}>
                                        <p><strong>Filter by</strong></p>
                                    </div>
                                    <div className="row row-sm">
                                        <div className="col-sm-8">
                                            {/* <Select.Async placeholder="Filter by (Type to search)"
                                                    name="megaFilter"
                                                    ref="megaFilter"
                                                    value={null}
                                                    onChange={this.filterHandle.bind(this)}
                                                    multi={true}
                                                    loadOptions={this.selectLoadMega}
                                                    style={textMarginBottom}
                                                    cache = {false}
                                                    defaultMenuIsOpen={true}
                                                /> */}
                                            <input type="text" id="mega-taginput" />
                                        </div>
                                        <div className="col-sm-4">
                                            <button id="updateMega" className="btn-sm btn btn-white" style={{ width: "100%" }} onClick={this.handleChange}>Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Mega Filter Modal */}
                    {pinToDashboardModal}

                    <div className="modal fade modal-wide" id="metricRangePopup" style={{}}>
                        <div className="modal-dialog">
                            <div className="modal-content" style={{ width: '120%', textAlign: "left" }}>
                                <div className="modal-header">
                                    <button aria-hidden="true" className="close" data-dismiss="modal" type="button">×</button>
                                    <h5 className="modal-title" id="alertData">Select Metric range</h5>
                                </div>
                                <div className="modal-body" style={{ overflow: 'auto' }}>
                                    <div>
                                        <div>
                                            {metricRangeInput}
                                        </div>
                                        <div className='col-md-4'><button id="doneMetricRange" className="btn-sm btn btn-white" data-dismiss="modal" type="button" onClick={this.handleMetricRangeSave}>Apply</button>
                                        </div>
                                        <div className='col-md-8'></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {toolPanelbutton} */}
                    {this.state.modalEvent ? <RangeMetricComponent eventType={this.state.modalEvent} allPropsData={this.props.allData.props} eventChange={this.rangeHandleModal} setMetricRange={this.props.setMetricRange} metricRange={this.props.metricRange} /> : null}

                    <div className={"d-flex flex-wrap justify-content-between w-100" }>
                    <div className={`d-flex align-items-center w-40`}  >
                    {breadcrumb}
                        </div>
                        {/* {window.innerWidth <= mobile_width && <hr className='wd-95p mg-y-5'></hr>} */}
                        {/* <div className={`d-flex col-sm-12 col-md-6  col-lg-6 ${jQuery(window).width() >= mobile_width ? 'justify-content-end' : ""}`} style={{ flexWrap: 'wrap' }}> */}
                        <div className={`d-flex align-items-center w-60`}>
{/* 
                            {checkIfOptionApplicable(this.props.allData.props.chartCat) ?
                            <div className={compare_button}>
                                {compare_charts}
                                <div className="dropdown-menu dropdown-menu-right">
                                    {compare_options.map(val => {
                                        return <div className={'d-flex align-items-center'}><a class="dropdown-item" onClick={() => this.handleCompareChart(val)}>{val}</a><div onClick={() => this.handleCompareChart('remove')} ><i data-feather='x' style={{ width: "17px", alignSelf: "center", cursor: "pointer" }}  onClick={() => this.handleCompareChart('remove')}></i></div></div>
                                    })}
                                </div>
                            </div>
                              : ""}  */}
                            <div className='pd-t-3 pd-b-3'>
                                {this.props.oldFilter ? null : checkIfFeatureApplicable('Calendar') ? calendarButton : ''}
                            </div>
                            <div className={more_button}>
                                {/* <InnerFilter/> */}
                                {MoreButton}
                                <div className="dropdown-menu dropdown-menu-end dropdown-menu-lg-end">
                                    {saveGridSetting}
                                    {checkIfFeatureApplicable('Cluster Analysis') || checkIfFeatureApplicable('Quadrant') ? Quadrant : ''}
                                    {checkIfFeatureApplicable('Compare') ? compare : ''}
                                    {/* {toolPanel}
                                {transpose} */}
                                    <li className="">
                                        {checkIfFeatureApplicable('Switch Chart') ? switchChart : ''}
                                        {checkIfFeatureApplicable('Switch Chart') ? <ul className="dropdown-menu dropdown-menu-end"  style={{ minWidth: "fit-content" }}>
                                            {chartToSwitch}
                                        </ul> : null}
                                    </li>
                                    {globalFilterLabels ? <a className="dropdown-item" href='javascript:void(0)' onMouseOver={() => jQuery('[data-toggle="tooltip"]').tooltip()} onClick={() => this.globalFilterHandler()} style={{ cursor: 'pointer' }}>Global Filter</a>:null}
                                    {showReports}
                                    {/* {refreshDatasets} */}
                                    {checkIfFeatureApplicable('Save Report') ? saveReport : ''}
                                    {/* {metricRange} */}
                                    {checkIfFeatureApplicable('Download') ? exportButton : ''}
                                    {checkIfFeatureApplicable('Download') ? exportButtonPDF : ''}
                                    {checkIfFeatureApplicable('Download') ? exportButtonCSV : ''}
                                    {checkIfFeatureApplicable('Pin To Dashboard') ? pin : ''}
                                    {configureKPIMCButton}
                                    {rangeMetricButton}
                                    {this.props.allData.props.pageName == "chart" ? chartConfig : ''}
                                    {checkIfFeatureApplicable('Save Report') ? save_report : ''}
                                    {shortName}
                                    {/* {styleHandle} */}
                                    {checkIfFeatureApplicable('Insight') ? enableInsight : ''}
                                    {dataLabelOverlap}
                                    {/* <a href='#'  className="dropdown-item" data-toggle="modal" data-target="#mega-filter-button">Mega Filter</a> */}
                                </div>
                            </div>
                            {/* {checkIfFeatureApplicable('Switch Chart') ? switchChart : ''} */}
                            {checkIfFeatureApplicable('Filter Setting') ? filter : ''}
                        </div>
                    </div>
                    {<ModalComponent modalConfig={globalFilterModalConfig} action={this.updateGlobalFilters} cancelEvent={this.modalCancel}/>}
                </div>);
        }
        else {
            return (
                <div className={datasetClassFinal} style={ this.props.ishomePage ? {marginBottom:"-20px"}:this.props.filter_open_body}>
                    <div className={`d-flex flex-wrap justify-content-between w-100`}>
                        <div className={`d-flex align-items-center w-40`}>
                            {breadcrumb}
                        </div>
                        {/* {window.innerWidth <= mobile_width && <hr className='wd-95p mg-y-5'></hr>} */}
                        <div className="d-flex align-items-center w-60">
                            {/* {dataset_div} */}
                            {window.location.pathname.includes('/SavedReport') && this.props.authData.companyName == 'Deloitte' ? <CalenderComponent /> : null}
                        </div>
                    </div>
                </div>
            )
        }
    }
};

// function mapStateToProps(state) {

//     let period = null;
//     if(state.dataSet.period){
//         period= typeof state.dataSet.period == "object" ? state.dataSet.period.value : state.dataSet.period;
//     }

//     return {
//         authData: state.dataSet.authData,
//         filter: state.dataSet.filter,
//         property: state.dataSet.property,
//         metric: state.dataSet.metric,
//         period: period,
//         SelectedBreakUp: state.dataSet.breakup,
//         metricRange: state.dataSet.metricRange,
//         sortOrder: state.dataSet.sortOrder,
//         startDate: state.dataSet.startDate,
//         endDate: state.dataSet.endDate,
//         limit: state.dataSet.limit,
//         propertyDisp: state.dataSet.propertyDisp,
//         breakupDisp: state.dataSet.breakupDisp,
//         metricDisp: state.dataSet.metricDisp,
//         transpose: state.dataSet.transpose,
//         dashbordGroups : state.dataSet.dashbordGroups
//     }
// }

function mapStateToProps(state) {
    return {
        oldFilter: state.dataSet.oldFilter || false,
        dataLabelConfig: state.dataSet?.dataLabelConfig?.dataLabelConfig,
        yAxis: state.dataSet?.dataLabelConfig?.yAxis,
        kpiMonitoringFunctions: state.dataSet.kpiMonitoringFunctions || [],
        kpiColumnConfig: state.dataSet.kpiColumnConfig || [],
        globalFilters: state.dataSet.globalFilters
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setFilter, removeFilter, setDashboardComponent, handle_transpose_table, handle_compare, handle_quadrant, setDashboardConfig, setInsightFunction, handle_dataLabel_Overlap, setMetricRange, getGlobalFilters
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Topfilters)
// export default Topfilters

// Constaint Name
// Insight
// Root Cause Analysis
// Download
// Calendar
// Filter Setting
// Search Bar
// Open In New Tab Dashboard
// Share On Dashboard
// Rename Dashboard
// Delete Dashboard
// Copy Dashboard
// Duplicate Dashboard
// Move Dashboard
// Delete Dashboard Component
// Edit Dashboard Component Name
// Add Dashboard Filters
// Save Report
// Pin To Dashboard
// Switch Chart
// Cluster Analysis
// Quadrant